import { api } from "../api/client";

/** Web Push on iPhone works only in the app added to the Home Screen (iOS 16.4+). */

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const b64ToBytes = (b64: string) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, c => c.charCodeAt(0));
};

export async function currentSubscription(): Promise<PushSubscription | null> {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return (await reg?.pushManager.getSubscription()) || null;
}

/** Ask for permission (must follow a tap) and register this device. */
export async function subscribeThisDevice(publicKey: string): Promise<void> {
  if (!pushSupported()) throw new Error(isStandalone() ? "This device can't receive notifications" : "Add Saga to your Home Screen first — iPhone only allows notifications from Home Screen apps");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications are blocked — allow them in iPhone Settings → Notifications → Saga");
  const reg = await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription())
    || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(publicKey) });
  await api.post("/api/phone/push/subscribe", { subscription: sub.toJSON() });
}

export async function unsubscribeThisDevice(): Promise<void> {
  const sub = await currentSubscription();
  if (sub) {
    await api.post("/api/phone/push/unsubscribe", { endpoint: sub.endpoint });
    await sub.unsubscribe().catch(() => {});
  }
}
